import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';

const Posts: React.FC = () => {
  return (
    <div className="dashboard-layout">
      <Sidebar />
      <main className="main-content">
        <Header />

        <div className="page-header">
          <div>
            <h1>Posts</h1>
            <p className="page-subtitle">Manage your published content across all platforms</p>
          </div>
        </div>

        <div className="content-grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))' }}>
          <Link to="/posts/compose" className="stats-card" style={{ textDecoration: 'none', cursor: 'pointer' }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>✍️</div>
            <h3>Compose</h3>
            <p>Create and publish new posts</p>
          </Link>

          <Link to="/posts/drafts" className="stats-card" style={{ textDecoration: 'none', cursor: 'pointer' }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>📝</div>
            <h3>Drafts <span className="status-dot blue" style={{ marginLeft: 8 }}></span></h3>
            <p>Posts saved as drafts</p>
          </Link>

          <Link to="/posts/live" className="stats-card" style={{ textDecoration: 'none', cursor: 'pointer' }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>🟢</div>
            <h3>Live <span className="status-dot green" style={{ marginLeft: 8 }}></span></h3>
            <p>Currently published posts</p>
          </Link>

          <Link to="/posts/scheduled" className="stats-card" style={{ textDecoration: 'none', cursor: 'pointer' }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>📅</div>
            <h3>Scheduled</h3>
            <p>Posts scheduled for future</p>
          </Link>

          <Link to="/posts/archived" className="stats-card" style={{ textDecoration: 'none', cursor: 'pointer' }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>📦</div>
            <h3>Archived</h3>
            <p>Archived posts</p>
          </Link>
        </div>
      </main>
    </div>
  );
};

export default Posts;
